import { render, staticRenderFns } from "./centerMap.vue?vue&type=template&id=810dd0b6&scoped=true"
import script from "./centerMap.vue?vue&type=script&lang=js"
export * from "./centerMap.vue?vue&type=script&lang=js"
import style0 from "./centerMap.vue?vue&type=style&index=0&id=810dd0b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810dd0b6",
  null
  
)

export default component.exports